import { createComponent } from '../lib';
import { VmTooltip } from '@vime/core';
import { define } from '../lib';
define('vm-tooltip', VmTooltip);
;
export default createComponent('vm-tooltip', new Set(['hidden', 'active', 'position', 'direction', 'isTouch', 'isMobile']));
//# sourceMappingURL=Tooltip.jsx.map